import { ReactInstaStories } from "../../../react-insta-stories/reactInstaStories";
import { Story } from "../../../react-insta-stories/interfaces";
import { StoriesEntity } from "./storiesAutoComponenta";
import { SiteMedia } from "../../../../siteWidgets/siteMedia";
import { FrontCopyButton } from "../../../../commonComponents/inline/frontCopyButton/frontCopyButton";
import * as classNames from "classnames"

interface StoriesItemProps {
    entity: StoriesEntity
    activeEntityIndex: number
    index: number
    storiesProgressTime: number
    lang: string
    onAllStoriesEnd: (nextSlideIndex: number) => void
    onStoriesClose: () => void
    handleNextSlide: () => void
    handlePrevSlide: () => void
    handleFinishedStories: () => void
}

interface StoriesItemState {
    isPaused: boolean
    stories: Story[]
    currentIndex: number
    isMuted: boolean
    windowHeight: number
}

const DICT = {
    "he": {
        "The link has been copied to the clipboard": "הקישור הועתק ללוח",
    },
    "ar": {
        "The link has been copied to the clipboard":"تم نسخ الرابط إلى الحافظة"
    }
}

export class StoriesItemMobile extends React.Component<StoriesItemProps, StoriesItemState> {
    constructor(props) {
        super(props);
        this.state = {
            isPaused: true,
            stories: [],
            currentIndex: 0,
            isMuted: false,
            windowHeight: window.innerHeight,
        }
    }

    componentDidMount() {
        const { entity: { slotId } } = this.props;
        this.getStories();
        this.getStoryCurrentIndex(slotId);

    }

    componentDidUpdate(prevProps) {
        const { entity: { slotId }, activeEntityIndex } = this.props;
        if (prevProps.activeEntityIndex !== this.props.activeEntityIndex) {
            this.getStories();
        }
        if (prevProps.activeEntityIndex !== activeEntityIndex) this.getStoryCurrentIndex(slotId);
    }

    componentWillUnmount() {
        const { entity: { slotId }, handleFinishedStories } = this.props;
        this.getStoryCurrentIndex(slotId);
        handleFinishedStories();
    }

    public getStories() {
        const { entity } = this.props;
        const {isMuted} = this.state;
        const {shouldDisplayStoryTitle} = entity;
        const storiesArray = entity.linkedItems.map((linkedItem) => {
            const isVideoStory = linkedItem.hasVideo;
            const url = isVideoStory && linkedItem.video ? linkedItem.video[0].high_res_link : linkedItem.promotionImageDetails.url;
            return { url, type: isVideoStory ? 'video' : "", muted: isMuted, link: linkedItem.publishedLink, header: {heading: linkedItem.title, subheading:"", profileImage:""}, storyClasses: shouldDisplayStoryTitle && linkedItem.specialData.titlePosition.value }
        });
        this.setState({ stories: storiesArray });
    }

    public onToggleMute = () => {
        const videoElement = document.querySelector(".storiesDisplayWrapper .splide__slide.is-active .storyContent video") as HTMLVideoElement;
        if (!videoElement) return;
        videoElement.muted ? this.setState({ isMuted: false }, () => videoElement.muted = false) : this.setState({ isMuted: true }, () => videoElement.muted = true);
    }

    public setStoryCurrentIndex = (slotId: string, index: number) => {
        localStorage.setItem(slotId, index.toString())
    }

    public getStoryCurrentIndex = (slotId: string) => {
        const currentIndex = localStorage.getItem(slotId);
        this.setState({ currentIndex: +currentIndex });
    }

    public onNextStory = () => {
        const { currentIndex, stories } = this.state;
        const { entity: { slotId }, handleNextSlide } = this.props;
        if (currentIndex === stories.length - 1) return handleNextSlide();

        this.setState({ currentIndex: this.state.currentIndex + 1 }, () => this.setStoryCurrentIndex(slotId, this.state.currentIndex));
    }

    public onPrevStory = () => {
        const { currentIndex } = this.state;
        const { entity: { slotId }, handlePrevSlide } = this.props;
        if (currentIndex === 0) return handlePrevSlide();
        this.setState({ currentIndex: this.state.currentIndex - 1 }, () => this.setStoryCurrentIndex(slotId, this.state.currentIndex));
    }

    public onStoryEnd = () => {
        const { entity: { slotId } } = this.props;
        const { currentIndex, stories } = this.state;
        if (currentIndex === stories.length - 1) return;

        this.setState({currentIndex: this.state.currentIndex + 1})
        const localStorageCurrentIndex = localStorage.getItem(slotId);
        this.setStoryCurrentIndex(slotId, +localStorageCurrentIndex + 1);
    }

    public render() {
        const { onStoriesClose, entity, index, activeEntityIndex, storiesProgressTime, onAllStoriesEnd, lang } = this.props;
        const { stories, currentIndex, isMuted, windowHeight } = this.state;
        const {promotionName, media, linkTarget, link, shouldDisplayStoryTitle} = entity;
        const isStoriesExist = stories.length;
        const millisecDefaultInterval = storiesProgressTime * 1000;
        const isMainStory = index === activeEntityIndex;
        const isCurrentStoryHasVideo = stories && stories[currentIndex] && stories[currentIndex].type === "video";
        const slotClass = classNames("slotView", {"muted": isMuted, "videoStory": isCurrentStoryHasVideo});
        const storyClass = `mainStory ${shouldDisplayStoryTitle ? "withHeader" : ""}`;

        return (
            <div className={slotClass} style={{ height: `${windowHeight}px` }}>
                {isMainStory &&
                    <>
                        <div className="closeBtn" onClick={onStoriesClose}></div>
                        <div className="muteBtn" onClick={this.onToggleMute}></div>
                    </>
                }
                <div className="storyItems">
                    {isMainStory && isStoriesExist ?
                        <div className={storyClass}>
                            <ReactInstaStories
                                stories={stories}
                                defaultInterval={millisecDefaultInterval}
                                onNext={this.onNextStory}
                                onPrevious={this.onPrevStory}
                                onAllStoriesEnd={() => onAllStoriesEnd(activeEntityIndex + 1)}
                                currentIndex={currentIndex}
                                onStoryEnd={this.onStoryEnd}
                            />
                            <div className="moreDetails" >
                                <FrontCopyButton popupText={DICT[lang][["The link has been copied to the clipboard"]]} url={stories[currentIndex] ? stories[currentIndex].link : null} classes="shareBtn" />
                                <div className="mediaArea">
                                    <div className="MediaCarousel">
                                        <SiteMedia
                                            data={media}
                                            width={50}
                                            height={50}
                                            videoSettings={null}
                                            itemLinkUrl={link.link.publishedLink}
                                            isImageLinkable={true}
                                            linkTarget={linkTarget}
                                        />
                                    </div>
                                    <div className="slotTitle">{promotionName}</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="storyPlaceholder">
                            <div className="loader"></div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}